import { render, staticRenderFns } from "./SliderContent.vue?vue&type=template&id=2dcd73c4&"
import script from "./SliderContent.vue?vue&type=script&lang=js&"
export * from "./SliderContent.vue?vue&type=script&lang=js&"
import style0 from "./SliderContent.vue?vue&type=style&index=0&id=2dcd73c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports